import { useApiQuery } from '../useApiQuery';
import { apiGet, operationsClient } from '@/lib/api';
import { jobEndpoints } from '@/lib/api/endpoints';
import { jobKeys } from '@/lib/queryKeys';

export interface JobPortalStatus {
  /** True when an un-revoked, un-expired portal token exists for the customer. */
  active: boolean;
  expiresAt: string | null;
}

/**
 * §13 — is a customer portal link live for this job's customer? Presence check
 * for the recurring-detail rail; the raw token never leaves the customer's email.
 */
export function useJobPortalStatus(jobId: string, enabled = true) {
  return useApiQuery<JobPortalStatus>({
    queryKey: [...jobKeys.detail(jobId), 'portal-status'],
    queryFn: () => apiGet<JobPortalStatus>(operationsClient, jobEndpoints.portalStatus(jobId)),
    enabled: Boolean(jobId) && enabled,
    showErrorToast: false,
  });
}
